<template>
  <div class="checkbox-container" style="position:relative;">
    <label class="el-checkbox">
      <span class="el-checkbox__input" :class="{'is-checked':visible}">
        <span class="el-checkbox__inner"></span>
        <input
          @change="changeCheckBox"
          type="checkbox"
          aria-hidden="false"
          class="el-checkbox__original"
          value
        />
      </span>
      <div class="el-checkbox__label">
        <span>
           我已阅读并接受<a class="policyBtn">隐私条款</a>：<br/>
           您的个人资料有可能会提交至长安马自达厂商及其授权经销商，与您进一步沟通试驾、购车等事宜。
        </span>
      </div>
    </label>
    <a v-maidian="'privacy'" @click="showPolicy" class="tipBox">&nbsp;</a>
    <!-- <a v-maidian="'privacy'" href="https://www.exeedcars.com/privacy" class="tipBox">&nbsp;</a> -->
  </div>
</template>
<script>
import { goUrl } from "@/utils/hybird"
import policy from './dialog/policy/index'
export default {
  props: ["value"],
  data() {
    return {
      visible: false
    };
  },
  created() {
    this.visible = this.value;
  },
  methods: {
    showPolicy(){
      policy({})
    },
    goUrl(url,linkId){
      goUrl(url,linkId)
    },
    changeCheckBox() {
      this.visible = !this.visible;
      this.$emit("input", this.visible);
    }
  }
};
</script>
<style lang="less" scoped="true">
.rem(@name,@px) {
    @{name}: unit(@px / 37.5, rem);
}
.checkbox-container{
  display: grid;
  width:calc(100% - 40px);
  margin-top:15px;
  margin-left:auto;
  margin-right:auto;
  grid-template-columns: 50px auto;
  user-select: none;
  *{
    user-select: none;
  }
}
.tipBox {
  height: 15px;
  position: relative;
  z-index:20;
  left:20px;
  width:100px;
}
.el-checkbox {
  color:#2C517F;
  font-weight: bold;
  font-size: 12px;
  position: relative;
  cursor: pointer;
  display: flex;
  width: 280px;
  user-select: none;
  text-align: left;
}
.el-checkbox__input {
  cursor: pointer;
  outline: none;
  display: inline-block;
  top:10px;
  position: relative;
  vertical-align: middle;
  left:0;
}
.el-checkbox__input.is-checked .el-checkbox__inner:before {
  content: "";
  display: block;
  background-color:#2C517F;
  width:8px;
  height:8px;
  position: absolute;
  left:2px;
  top:2px;
}
.policyBtn{
  text-decoration: underline;
}
.el-checkbox__inner {
  display: block;
  position: relative;
  border-radius: 2px;
  width:12px;
  height:12px;
  z-index: 1;
  top:-8px;
  right:5px;
  border:1px solid #2C517F;
}
.el-checkbox__input.is-checked .el-checkbox__inner:after {
  transform: rotate(45deg) scaleY(1);
}
.el-checkbox__original {
  opacity: 0;
  outline: none;
  position: absolute;
  margin: 0;
  width: 0;
  height: 0;
  z-index: -1;
}
.el-checkbox__label {
  display: inline-block;
  line-height: 19px;
  font-size: 10px;
}
</style>
